<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

		<div :style="{ display: mode === 'search' ? 'block' : 'none' }">
        <!-- srchTop_wrap -->
	        <div class="srchTop_wrap">
	                    <article class="srch_basic">
	                        <div class="srch_grup">
	                            <ul class="w50">
	                                <li class="tit_150">Contents Type</li>
	                                <li data-input-type="select" class="w100-150">
	                                    <select class="slt_white w100" v-model="distinctionType" @change="clickSearch()">
	                                        <option value="SB" selected>Service Bulletin</option>
	                                        <option value="MX" >Service Bulletin(Mobile)</option>
	                                    </select>
	                                </li>
	                            </ul>
	                            <ul class="w50" v-if="distinctionType == 'SB'">
	                                <li class="tit_150">{{ $t('FIELD.GLOBAL.CATEGORY') }}</li>
	                                <li data-input-type="select" class="w100-150">
	                                    <select class="slt_white w100p"
	                                                    id="categoryStatus"
	                                                    v-model="categoryStatus"
	                                                    @change="changeCategory1($event)"
	                                            >
	                                                <option value="" selected>ALL</option>
	                                                <option v-if="categoryComboList.length > 0"
	                                                        v-for="item in categoryComboList"
	                                                        :key="item.code"
	                                                        :value="item.code"
	                                                >{{item.codeName}}</option>
	                                            </select>
	                                </li>
	                            </ul>
	                            <ul class="w50" v-if="distinctionType == 'SB'">
	                                <li class="tit_150">Guide Type</li>
	                                <li data-input-type="select" class="w100-150">
	                                    <select class="slt_white w100" v-model="guideType">
	                                        <option value="" selected>Select Guide Type</option>
                            					<option value="ALL">ALL (including five types below)</option>
							                    <option value="S">S/W & Firmware</option>
							                    <option value="A">Alternative Parts</option>
							                    <option value="O">On Site Check Guide</option>
							                    <option value="R">Repair Information & Tips</option>
							                    <option value="M">Manufacturing BOM Change</option>
	                                    </select>
	                                </li>
	                            </ul>
	                            <ul class="w50">
	                                <li class="tit_150">Role</li>
	                                <li data-input-type="select" class="w100-150">
	                                    <select class="slt_white w100" v-model="roleStatus">
	                                        <option value selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
	                                        <option value="1">Approval</option>
	                                        <option value="2">Consent</option>
	                                        <option value="3">Post Approval</option>
	                                        <option value="4">Parallel Consent</option>
	                                        <option value="7">Parallel Approval</option>
	                                        <option value="9">Notification</option>
	                                    </select>
	                                </li>
	                            </ul>
	                        </div>
	                        <div class="srch_grupR">
	                            <span class="btn">
	                                <a href="JavaScript:" class="btn_srch" @click="clickSearch(1)">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
	                            </span>
	                        </div>
	                    </article>
	                    
	            </div>
	            <!-- Grid -->
		        <div class="grid_wrap" >
		             <!-- left: total count -->
		             <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em></div>
		             <!-- right: button area -->
		             <div class="btn_wrap">
		                 <a href="JavaScript:" class="btn_blue" @click="clickDelete()" title>{{$t('BUTTON.GLOBAL.DELETE')}}</a>
		                 <a href="JavaScript:" class="btn_blue" @click="clickCreate()" title>{{$t('BUTTON.GLOBAL.CREATE')}}</a>
		             </div>
		            <!-- Grid -->
		                   <code-list-grid
		                       :gridId="gridId"
		                       :ref="gridId"
		                       :data="gridData"
		                       :columns="columns"
		                       :options="options"
		                       :pageOptions="pageOptions"
		                       :key="gridKey"
		                       :click="contentClick"
		                       :isTotalCount="false"
		                       :menuMode="menuMode"
		                        v-if="distinctionType == 'SB'"
		                   />
		                    <code-list-grid
		                       :gridId="gridId"
		                       :ref="gridId"
		                       :data="gridData"
		                       :columns="columnsMX"
		                       :options="options"
		                       :pageOptions="pageOptions"
		                       :key="gridKey"
		                       :click="contentClick"
		                       :isTotalCount="false"
		                       :menuMode="menuMode"
		                        v-if="distinctionType != 'SB'"
		                   />
		                   
<!-- 		                   <expired-grid -->
<!-- 				                :gridId="gridId" -->
<!-- 				                :ref="gridId" -->
<!-- 				                :data="gridData" -->
<!-- 				                :columns="columns" -->
<!-- 				                :options="options" -->
<!-- 				                :pageOptions="pageOptions" -->
				                
<!-- 				                :click="contentClick" -->
<!-- 				                :isTotalCount="false" -->
				                
<!-- 				                @grid-total-count="setTotalCount" -->
<!-- 				            /> -->
		        </div>
	        </div>
        <content-view v-if="mode == 'view'" :pCategoryId="categoryId"></content-view>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import ApprovalManageListGrid               from './ApprovalManageListGrid';
// import ApprovalManageListGrid               from '~c/ToastGrid';
import ExpiredKnowledgeListGrid             from '../expiredKnowledge/ExpiredKnowledgeListGrid';
import CodeAdminView 						from './ApprovalManageView';
// import CodeListGrid 						from '~c/ToastGrid';

// require('moment-jdateformatparser');

export default {
    name: 'ApprovalManageList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'code-list-grid'    : ApprovalManageListGrid,
        'expired-grid'      : ExpiredKnowledgeListGrid,
        'content-view'      : CodeAdminView,
    },
    data() {
        return {
       	 	isLoading: true,
            mode: 'search', // 'view'
            searchStatus: 'done', // 'loading', 'disabled'
            menuMode: 'CODE',
            pageTitle: 'Approvla Manage',
            
            guideType : '',
            roleStatus : '',
            categoryStatus : '',
            distinctionType : 'SB',
            
            codeName: '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            gridKey: 0,
            resultCount: 0,
            categoryId: {},
            gridData: [],
            slectList: [],
            
            categoryComboList: [],     // Category 1 List

            gridId: 'ApprovalManageGrid',
            columns: [
            	{
                    header: 'No',
                    name: 'ID_KEY',
                    hidden: true, 
                },
                {
                    header: 'Contents Type',
                    name: 'DISTINCTION',
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Category',
                    name: 'CATEGORY',
                    sortable: true,
                },
               	{
                    header: 'Guide Type',
                    name: 'GUIDETYPE',
                    sortable: true,
                },
                {
                    header: 'Role',
                    name: 'ROLE',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Sort',
                    name: 'SORTORD',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Email',
                    name: 'EMAIL',
                    align: 'center',
                    hidden: true,
                },
                {
                    header: 'User Id',
                    name: 'USERID',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Name',
                    name: 'NAME',
                    align: 'center',
                    sortable: false,
                },
            ],
            
            columnsMX: [
            	{
                    header: 'No',
                    name: 'ID_KEY',
                    hidden: true, 
                },
                {
                    header: 'Contents Type',
                    name: 'DISTINCTION',
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Category',
                    name: 'CATEGORY',
                    sortable: true,
                },
                {
                    header: 'Role',
                    name: 'ROLE',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Sort',
                    name: 'SORTORD',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Email',
                    name: 'EMAIL',
                    align: 'center',
                    hidden: true,
                },
                {
                    header: 'User Id',
                    name: 'USERID',
                    align: 'center',
                    sortable: true,
                },
                {
                    header: 'Name',
                    name: 'NAME',
                    align: 'center',
                    sortable: false,
                },
            ],
            
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        }
    },
    computed: {},
    directives: { resize },
    methods: {
    	initLoad() {
        	this.setCategory();
        	this.search(1);
//         	this.columns = this.getDynamicCols();
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const  codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        
        // 첫번째 카테고리 설정
        setCategory() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.categoryComboList = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        
        async search(pageNo) {
            if (!pageNo) pageNo = 1;
			
            const formData = this.prepSearchParams(pageNo);

            SDLUtil.showLoadingBar(true);
            this.gridData = [];
            this.searchStatus = 'loading';
            return axios
//                 .post(`${SDLUtil.API_URL}/basis/admin/system/code/codeAdminList.skp`, qs.stringify(formData), {
                .post(`${SDLUtil.API_URL}/basis/admin/knowledgeManager/approval/ApprovalManageListSearch.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
                    this.gridData = resp.data.rows;
                    this.searchStatus = 'done';
                    this.currentPage = pageNo;
                    this.gridKey += 1; // This will re-render grid
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        
        clickDelete() {
            let that = this;
            if(this.slectList.length === 0) {
                SDLUtil.alert('Please Select delete data. ');
            } else {
                SDLUtil.confirm({
                    title: "BUTTON.GLOBAL.DELETE",
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => {
                        let params = { slectList: that.slectList , distinction : that.distinctionType};
                        return  axios.post(
                                    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/approval/approvalDelete.skp`,
                                    qs.stringify(params),
                                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                                )
                                .then(res => {
                                	 SDLUtil.alert({
                                            title: 'BUTTON.GLOBAL.DELETE',
                                            msg: 'Delete Success.',
                                            onOkEvt: () => {
                                            	this.goList();
                                            }
                                        });
                                })
                                .catch(err => {
                                    SDLUtil.errorAlert(err);
                                });
                    }
                });
            };
        },
        
        setCheckedList(rtnList = []) {
            Vue.$log.info('▶ApprovalManageList.vue setCheckedList', rtnList);
            this.slectList = rtnList;
        },
        
        // 그리드 row 클릭 시...
        clickCreate() {
            this.categoryId = null;
            this.mode = 'view';
        },
        // 그리드 row 클릭 시...
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            this.fetchContent(event.rowKey);
        },
        // 상세페이지로 이동
        fetchContent(rowIdx) {
            let item = this.gridData[rowIdx];
            SDLUtil.showLoadingBar(true);
			
            let distinctionKey = '';
            if(item.DISTINCTION === 'Service Bulletin') {
            	distinctionKey = 'SB';
            }else if (item.DISTINCTION === 'Mobile') {
            	distinctionKey = 'MX';
            }
            this.categoryId = {ID_KEY : [item.ID_KEY], distinction : distinctionKey};
            this.mode = 'view';

            window.scrollTo(0, 0);
            SDLUtil.showLoadingBar(false);
        },
        prepSearchParams(pageNo, exclude = []) {
            if (!pageNo) pageNo = 1;

            let params = {
                page: pageNo,
                currentPage: pageNo,
                perPage: this.perPage,
                distinction: this.distinctionType,
                categoryStatus: this.categoryStatus,
                guideType: this.guideType,
                roleStatus: this.roleStatus
            };
            return params;
        },
        clickSearch() {
            this.search(1);
        }, // clickSearch
        goList(data) {
            this.search(this.currentPage);
            this.mode = 'search';
        }
    }, // methods
    created() {
        EventBus.$on('goCodeList', this.goList);
        EventBus.$on('approval-manage-list',  rtnList     => { this.setCheckedList(rtnList); });
    },
    mounted() {
        this.initLoad();
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goCodeList');
        EventBus.$off('approval-manage-list');
    },
};
</script>

<style>
.zindex9999 { z-index: 9999; }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/approval/ApprovalManageList.vue